import { render, staticRenderFns } from "./promptDeposited.vue?vue&type=template&id=2f1cfad2&scoped=true"
import script from "./promptDeposited.vue?vue&type=script&lang=js"
export * from "./promptDeposited.vue?vue&type=script&lang=js"
import style0 from "./promptDeposited.vue?vue&type=style&index=0&id=2f1cfad2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1cfad2",
  null
  
)

export default component.exports